import script from "./modalMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./modalMenu.vue?vue&type=script&lang=ts&setup=true"

import "./modalMenu.vue?vue&type=style&index=0&id=29b793ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b793ee"]])

export default __exports__